module.exports = __webpack_public_path__ + "static/1-19a1b12832d7f136bbcb884bb92d3df5.jpg";